module.exports = __webpack_public_path__ + "img/124.ab20c8eb.png";